import React from 'react';
import { Spin } from 'antd';
import TagRender from '../common/TagRender';
import { getIdMap } from '../helpers/helpers';
import {
  getProjectBucketTemplates,
  createProjectToBucketsMap,
} from '../buckets/bucketHelpers';

export default {};

export const getDisplayColumns = ({
  divisionMap,
  useRedesign,
  labels,
  projectToLabel,
  bucketMap,
  bucketTemplateProjectMap,
}) => {
  const baseColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      width: 200,
      render: (name, record) => (
        <div>
          {record?.isLoading && (
            <Spin
              size="medium"
              style={{
                position: 'absolute',
                width: '100px',
                height: '100%',
                zIndex: 100,
              }}
            />
          )}
          {name}
        </div>
      ),
    },
    {
      title: 'Number',
      dataIndex: 'number',
      width: 100,
    },
    {
      title: 'Address',
      dataIndex: 'address',
      width: 100,
    },
    {
      title: 'City',
      dataIndex: 'city',
      width: 100,
    },
    {
      title: 'Division',
      dataIndex: 'division',
      width: 100,
      render: (_, record) => (
        <TagRender
          tagMap={divisionMap}
          tagIds={[record.divisionId]}
          useRedesign={useRedesign}
        />
      ),
    },
    {
      title: 'Active Users',
      dataIndex: 'activeUsers',
      width: 70,
      render: (users) => users?.length ?? 0,
    },
    {
      title: 'Inactive Users',
      dataIndex: 'inactiveUsers',
      width: 70,
      render: (users) => users?.length ?? 0,
    },
    {
      title: 'Customer',
      dataIndex: 'customer',
      width: 100,
    },
  ];

  const projectLabels = labels.filter((label) => label.type === 'projects');
  if (projectLabels.length > 0) {
    const projectLabelMap = getIdMap(projectLabels);
    baseColumns.push({
      title: 'Labels',
      dataIndex: 'labels',
      width: 100,
      render: (_, record) => {
        const {
          [record.id]: ourLabels = [],
        } = projectToLabel;
        return (
          <TagRender
            tagMap={projectLabelMap}
            tagIds={ourLabels}
            useRedesign={useRedesign}
            labelKey="title"
          />
        );
      },
    });
  }

  // Add bucket template columns, only include templates that have projects as downstream type
  Object.keys(bucketTemplateProjectMap).forEach((bucketTemplateId) => {
    const {
      name: bucketTemplateName,
      projectMap: projectToBucketsMap,
    } = bucketTemplateProjectMap[bucketTemplateId];
    baseColumns.push({
      title: bucketTemplateName,
      dataIndex: bucketTemplateId,
      width: 120,
      render: (_, record) => {
        const projectBuckets = projectToBucketsMap[record.id] ?? [];
        const bucketIds = projectBuckets.map((b) => b.id);

        return (
          <TagRender
            tagMap={bucketMap}
            tagIds={bucketIds}
            useRedesign={useRedesign}
          />
        );
      },
    });
  });

  return baseColumns;
};

export const FIELDS_BY_EDIT_STEP = [
  [
    'name',
    'number',
    'divisionId',
    'customer',
    'firstApprover',
    'secondApprover',
    'projectTypeId',
    'geofence',
    'info',
    'city',
    'qboClassId',
    'address',
  ],
  [
    'customBillingRate',
    'billingRateId',
    'materialDiscount',
    'billingContact',
    'hasContract',
    'contractExpiration',
    'contractReminder',
  ],
];

export const PROJECT_FILTER_VIEW_FIELDS = [
  {
    field: 'active',
    defaultValue: [],
  },
  {
    field: 'projectTypeId',
    defaultValue: [],
  },
  {
    field: 'labels',
    defaultValue: [],
  },
  {
    field: 'contractExpiration',
    defaultValue: [],
  },
];

export const BUCKET_TEMPLATE_PREFIX = 'bucketTemplate-';
